
import { Line } from "vue-chartjs";
import moment from "moment";

export default {
  extends: Line,
  props: {
    dataSet: {}
  },
  computed: {
    chartData() {
      return {
        labels: this.dataSet.labels,
        datasets: [
          {
            label: "Tensi",
            yAxisID: "A",
            type: "bar",
            data: this.dataSet.tensi,
            barThickness: 5,
            backgroundColor: "black",
            order: 5
          },
          {
            label: "Nadi",
            yAxisID: "A",
            data: this.dataSet.nadi,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "red",
            backgroundColor: "red"
          },
          {
            label: "Nafas",
            yAxisID: "C",
            data: this.dataSet.nafas,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "orange",
            backgroundColor: "orange"
          },
          {
            label: "Suhu",
            yAxisID: "B",
            data: this.dataSet.suhu,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "blue",
            backgroundColor: "blue"
          },
          {
            label: "MAP",
            yAxisID: "A",
            data: this.dataSet.mapVal,
            pointRadius: 3,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "green",
            backgroundColor: "green"
          }
        ]
      };
    },
    options() {
      return {
        scales: {
          xAxes: [
            {
              // type: "time",
              // time: {
              //   unit: "month"
              // }

              ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, values) {
                  const prevDate =
                    index > 0
                      ? moment(values[index - 1]).format("YYYY-MM-DD")
                      : null;
                  // console.log(prevDate);
                  if (
                    index === 0 ||
                    prevDate !== moment(value).format("YYYY-MM-DD")
                  ) {
                    return value;
                  } else {
                    return moment(value).format("HH:mm");
                  }
                }
              }
            }
          ],
          yAxes: [
            {
              id: "A",
              scaleLabel: {
                display: true,
                labelString: "Tensi / Nadi / MAP"
              },
              display: true,
              position: "left",
              ticks: {
                min: 50,
                max: 300,
                stepSize: 50,
                beginAtZero: false
              }
            },
            {
              id: "B",
              scaleLabel: {
                display: true,
                labelString: "Suhu"
              },
              display: true,
              position: "right",
              ticks: {
                min: 35,
                max: 40,
                stepSize: 1,
                beginAtZero: false
              }
            },
            {
              id: "C",
              scaleLabel: {
                display: true,
                labelString: "Nafas"
              },
              display: true,
              position: "right",
              ticks: {
                min: 10,
                max: 60,
                stepSize: 10,
                beginAtZero: false
              }
            }
          ]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || "";

              if (String(label).toLowerCase() == "tensi") {
                const val: Array<number> = JSON.parse(
                  tooltipItem.value.replace(/NaN/g, "null")
                );
                tooltipItem.value = val.join(" / ");
              }

              return `${label} : ${tooltipItem.value}`;
            }
          }
        }
      };
    }
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    dataSet() {
      this.renderChart(this.chartData, this.options);
    }
  }
};
